import validationSchema from 'validation/user/forgot_password';
import { Grid, TextField, Button, Divider } from 'components/ui';
import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { WideForm } from 'components/styles_components/form';
import { LoginLink } from 'utils/link';
import { StyledLink } from 'components/styles_components/link';
import { DividerContainer } from 'components/styles_components/container';

const ForgotPasswordForm = ({ initialValues, onSubmit, processing, children }) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema(intl)}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
        <WideForm onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="dense"
            id="email"
            name="email"
            label={intl.formatMessage({ id: 'user.email' }) + ' *'}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.email && Boolean(errors.email)) || undefined}
            helperText={touched.email && errors.email}
          />
          {children}
          <Button
            sx={{ mt: 1 }}
            fullWidth
            disabled={processing}
            color="primary"
            variant="contained"
            type="submit"
          >
            <FormattedMessage id="button.remind_password" />
          </Button>
          <DividerContainer />
          <Divider>
            <FormattedMessage id="auth.register.account" />
          </Divider>
          <DividerContainer />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <StyledLink to={LoginLink()}>
              <FormattedMessage id="button.login" />
            </StyledLink>
          </Grid>
        </WideForm>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
